<template>
    <AdminAccountList :pk="'DAL-'" :lockedFilters="lockedFilters" :hidePartnerCompanyFilter="false"
        :hideCustomerFilter="false" :hideDepartmentFilter="!!departmentId" :hideUserTypeFilter="true"
        :userTypeFilterOptions="userTypeFilterOptions">
    </AdminAccountList>
</template>


<script>
import AdminAccountList from '@/views/admin/accounts/AdminAccountList.vue';

export default {
    name: "PartnerAccountList",
    props: {},
    components: {
        AdminAccountList,
    },

    data() {
        return {};
    },

    mounted() { },

    methods: {},

    computed: {
        departmentId() {
            return this.$route.params.departmentId;
        },
        lockedFilters() {
            var filters = {};
            if (this.departmentId) {
                filters.DepartmentIdList = [this.departmentId];
            }
            return filters;
        },
        userTypeFilterOptions() {
            return [5];
        },
    },

    watch: {},
};
</script>


<style lang='scss'></style>